module.exports = "/_next/static/images/logo-yatoo-vertical.nc-648f78f44a14883e694c47eb17bd0f16.png";